import _ from 'lodash';

import { FeatureFlagState } from 'common-src/models/FeatureFlag';

export const stateOptions = Object.entries(FeatureFlagState).map((x) => ({
  value: x[1],
  label: _.startCase(x[0]),
}));
